import {css} from '@emotion/react';
import styled from '@emotion/styled';
import {ChipGroup, Flex} from '@travel-frontend/ui-components';

import {FilterHeadline} from '@/components/FilterHeadline';

type Props = {
  isSwipable?: boolean;
};

export const Container = styled(Flex)<Props>(
  ({theme, isSwipable}) => css`
    background-color: ${theme.colors.backgroundTertiary};
    ${theme.spacing('padding', 'boxes/medium')};
    border-radius: 5px;

    ${theme.isAccessibleTheme &&
    css`
      border: 1px solid ${theme.colors.borderPrimary};
    `}

    ${isSwipable &&
    css`
      overflow-x: auto;
      max-width: 100%;

      ${FilterHeadline} {
        ${theme.typography.headlineSmall};
      }

      ${ChipGroup} {
        padding: 4px;
        margin: -4px;
        ${theme.spacing({
          gap: 'global/medium',
          paddingBottom: 'global/medium',
        })};
        align-items: center;
      }
    `}
  `
);
